


































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";

type taint = {
  key: string;
  value: string;
  effect: "NoSchedule" | "PreferNoSchedule" | "NoExecute";
};
const effects = [
  {
    label: "不允许调度",
    value: "NoSchedule"
  },
  {
    label: "尽量不调度",
    value: "PreferNoSchedule"
  },
  {
    label: "驱逐已有容器组",
    value: "NoExecute"
  }
];
export default Vue.extend({
  name: "StainEdit",
  data() {
    return {
      dialog: false,
      loading: false,
      effects,
      ruleForm: {
        hosts: [] as string[],
        taints: [{ key: "", value: "", effect: "NoSchedule" }] as taint[]
      }
    };
  },
  methods: {
    show(data: string[], taints: string) {
      // 已存在的 污点 可能为 null
      const editTaints: taint[] = JSON.parse(taints);
      this.ruleForm.hosts = data;
      if (Array.isArray(editTaints)) {
        this.ruleForm.taints = [...editTaints];
      }
      this.dialog = true;
    },
    delTaint(index: number) {
      this.ruleForm.taints.splice(index, 1);
    },
    addTaint() {
      this.ruleForm.taints.push({ key: "", value: "", effect: "NoSchedule" });
    },
    quit() {
      this.ruleForm = {
        hosts: [],
        taints: [{ key: "", value: "", effect: "NoSchedule" }]
      };
      (this.$refs.ruleForm as Form).clearValidate();

      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as any).validate((valid: any) => {
        if (valid) {
          this.loading = true;

          this.create();
        }
      });
    },
    create() {
      axios
        .post("/hosts/taints", this.ruleForm)
        .then(() => {
          this.quit();
          this.$message.success("污点添加成功");
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
